import axios from 'axios';

export const HOST_API = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.request.use(
    config => {
        // const token = localStorage.getItem('token');
        // if (token) {
        //     config.headers.Authorization = `Bearer ${token}`;
        // }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    res => res,
    error =>
        Promise.reject(
            (error.response && error.response.data) || 'Something went wrong'
        )
);

export default axiosInstance;

export const fetcher = async args => {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.post(url, { ...config });

    return res.data;
};
